angular.module('impactx.search').controller('CardTabContainerCtrl', [
    '$element',
    '$timeout',
    'TranslationService',
    '$scope',
    CardTabContainerController
]);

function CardTabContainerController($element, $timeout, TranslationService, $scope) {
    var self = this;
    var containerElement, inkBar, paneCount = 1;
    self.scrollPositionIndex = 0;
    self.maxScrollPosition = 0;
    self.canScrollRight = true;
    self.panes = [];
    self.selectedPane = {};
    self.showScroll = false;
    self.hasPanes = true;
    self.contentIsUpdated = false;

    self.$onInit = function () {
        containerElement = $element;
        self.trns.showAll = TranslationService.get('showAll');
    };

    self.addPane = function (pane) {
        var selectedPanes = self.panes.filter(function (paneEntry) {
            return paneEntry.selected;
        });
        if (selectedPanes.length === 0 && pane.amount > 0) {
            setTabSelection(pane);
        }
        pane.order = paneCount;
        self.panes.push(pane);
        paneCount++;
        self.hasPanes = true;

        $scope.$watch(function () {
            return pane.amount;
        }, function (newVal, oldVal) {
            checkEmptyPanes(pane, newVal);
            checkPaneSelection(newVal, oldVal);
        });
    };

    self.selectTab = function (pane, forceOpen) {
        if (forceOpen) {
            self.isOpen = true;
        }
        setTabSelection(pane);
        self.updateInkBar();
    };

    function setTabSelection(pane) {
        self.scrollPositionIndex = 0;
        angular.forEach(self.panes, function (paneEntry) {
            paneEntry.selected = false;
        });
        if (pane) {
            pane.selected = true;
            self.selectedPane = pane;
        }
        else {
            self.selectedPane = {};
        }
    }

    self.scrollLeft = function () {
        if (self.scrollPositionIndex > 0) {
            self.scrollPositionIndex--;
            setScrollPosition();
        }
    };

    self.scrollRight = function () {
        if (self.selectedPane.needsUpdate && angular.isFunction(self.selectedPane.onContentUpdate)) {
            var contentUpdate = self.selectedPane.onContentUpdate({
                pageSize: 3,
                pageNumber: ++self.selectedPane.scrollPosition
            });
            if (contentUpdate.then) {
                self.contentIsUpdated = true;
                contentUpdate.then(function (result) {
                    self.contentIsUpdated = false;
                    // self.selectedPane.actualAmount = result;
                });
            }
        }
        if (self.canScrollRight) {
            self.scrollPositionIndex++;
            setScrollPosition();
        }
    };

    self.toggleCards = function () {
        self.isOpen = !self.isOpen;
    };

    self.onResize = function () {
        setScrollPosition();
    };

    self.setInkBar = function (inkBarElement) {
        inkBar = inkBarElement;
    };

    self.updateInkBar = function () {
        $timeout(function () {
            var selectedElement = containerElement.find('.selected');
            if (selectedElement.length > 0) {
                var width = selectedElement.width() - 32;
                var offset = selectedElement.position().left + 16;

                if (inkBar) {
                    inkBar.style.width = width + 'px';
                    inkBar.style.left = offset + 'px';
                }
            }
            else {
                inkBar.style.width = '0px';
            }
            setScrollPosition();
        }, 100);
    };

    function setScrollPosition() {
        var scrollPane = containerElement.find('.card-pane');
        var scrollArea = containerElement.find('.card-pane-animation');
        var cardWidth = parseInt(self.selectedPane.cardWidth) + 8;
        var scrollOffset = self.scrollPositionIndex * cardWidth * 3;
        if (scrollArea) {
            scrollArea.animate({
                scrollLeft: scrollOffset
            }, 500);
        }

        $timeout(function () {
            if (scrollArea[0]) {
                self.maxScrollPositionReached = scrollArea[0].scrollWidth  <= scrollOffset + scrollPane.width();
                self.showScroll = self.selectedPane.actualAmount * cardWidth >= scrollPane.width();
                self.selectedPane.needsUpdate = self.selectedPane.actualAmount < self.selectedPane.amount;
                self.canScrollRight = self.selectedPane.needsUpdate || !self.maxScrollPositionReached;
            }
        });
    }

    function checkEmptyPanes(pane, newAmount) {
        var index = self.panes.indexOf(pane);
        if (newAmount == 0) {
            self.panes.splice(index, 1);
            pane.selected = false;
        }
        else {
            if (index < 0) {
                self.panes.splice(pane.order, 0, pane);
            }
        }
        if (self.panes.length > 0) {
            self.selectTab(self.panes[0]);

        }
        self.hasPanes = self.panes.length > 0;
    }

    function checkPaneSelection(newVal, oldVal) {
        if (self.isOpen && newVal !== oldVal) {
            if (newVal == 0 || oldVal == 0) {
                if (!self.selectedPane.selected && newVal > 0) {
                    for (var i = 0; i < self.panes.length; i++) {
                        if (self.panes[i].amount > 0) {
                            self.selectTab(self.panes[i]);
                            break;
                        }
                    }
                }
                else if (self.selectedPane.selected && newVal == 0) {
                    if (self.selectedPane.amount == 0) {
                        self.selectTab(null);
                        for (var j = 0; j < self.panes.length; j++) {
                            if (self.panes[j].amount > 0) {
                                self.selectTab(self.panes[j]);
                                break;
                            }
                            else {
                                self.isOpen = false;
                            }
                        }
                    }
                }
            }
            else {
                self.updateInkBar();
            }
        }
    }
}